import { SummaryText as Container } from './styles'

export function SummaryText({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>
}
